export const userFormInputs = {
  firstName: '',
  lastName: '',
  email: '',
};
